import { getTopGames } from '@services/queries'
import { useQuery } from 'react-query'
import {
  getListGames,
  getProviderFreespins,
  getGamesProviders,
  getGameTypes,
  getGameSubtypes,
} from './queries/games'

export function useTopGames(playerId, days, limit) {
  const info = useQuery(['top_games_session', playerId, days, limit], () =>
    getTopGames(playerId, days, limit),
  )

  return info
}

export function useGames(providerId) {
  const info = useQuery(['list_games', providerId], () =>
    getListGames(providerId),
  )

  return info
}

export function useProviderFreeSpins(enabled = true) {
  const info = useQuery(['provider_freespins'], () => getProviderFreespins(), {
    enabled,
  })

  return info
}

export function useGamesProviders(enabled = true) {
  const info = useQuery(['games_providers'], () => getGamesProviders(), {
    enabled,
  })

  return info
}

export function useGameTypes(enabled = true) {
  const info = useQuery(['game_types'], () => getGameTypes(), {
    enabled,
  })

  return info
}

export function useGameSubtypes(enabled = true) {
  const info = useQuery(['game_subtypes'], () => getGameSubtypes(), {
    enabled,
  })

  return info
}
